/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_Page_Message_GenericInputs */

const de_commons_error_page_message_generic = /** @type {(inputs: Commons_Error_Page_Message_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.`)
};

/** @type {(inputs: Commons_Error_Page_Message_GenericInputs) => LocalizedString} */
const en_commons_error_page_message_generic = de_commons_error_page_message_generic;

/**

* @param {Commons_Error_Page_Message_GenericInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_page_message_generic = /** @type {((inputs?: Commons_Error_Page_Message_GenericInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_Page_Message_GenericInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_page_message_generic(inputs)
	return en_commons_error_page_message_generic(inputs)
});